var exports = {
  "Nr": "DiscoveryGuildCard.module__card___cEdSVS",
  "L8": "DiscoveryGuildCard.module__cardButton___cEdSVS",
  "vK": "DiscoveryGuildCard.module__banner___cEdSVS",
  "_e": "DiscoveryGuildCard.module__bannerImage___cEdSVS",
  "Dw": "DiscoveryGuildCard.module__bannerScrim___cEdSVS",
  "Kk": "DiscoveryGuildCard.module__icon___cEdSVS",
  "rf": "DiscoveryGuildCard.module__body___cEdSVS",
  "$": "DiscoveryGuildCard.module__titleRow___cEdSVS",
  "fh": "DiscoveryGuildCard.module__nameText___cEdSVS",
  "h_": "DiscoveryGuildCard.module__description___cEdSVS",
  "qr": "DiscoveryGuildCard.module__footer___cEdSVS",
  "dJ": "DiscoveryGuildCard.module__stat___cEdSVS",
  "gW": "DiscoveryGuildCard.module__statDot___cEdSVS",
  "rR": "DiscoveryGuildCard.module__statDotOnline___cEdSVS" + " " + "DiscoveryGuildCard.module__statDot___cEdSVS",
  "rb": "DiscoveryGuildCard.module__statDotMembers___cEdSVS" + " " + "DiscoveryGuildCard.module__statDot___cEdSVS",
  "KA": "DiscoveryGuildCard.module__statText___cEdSVS",
};

module.exports = exports;
